// removed by extract-text-webpack-plugin
module.exports = {"map":"styles__map___3DH-s"};


//////////////////
// WEBPACK FOOTER
// ./src/views/styles.less
// module id = 1918
// module chunks = 0